module.exports = __webpack_public_path__ + "static/media/Login-Logo.1cd42e2c.png";